import BasicModelFactory from "../BasicModelFactory";
import RouteModel from "./RouteModel";
import RouteChoice, {IRouteChoices} from "./RouteChoice";
import {IPopulateIDs, IRouteIDs} from "../../type-interface/ModelFactoryInterface";
import {getManager} from "../../../manager/Manager";
import {IStringObject} from "../../../common/SimpleInterface";
import {cloneObjectTo} from "../../../common/SiteHelper";
import eventBus from "../../../event/EventBus";

export default class RouteFactory extends BasicModelFactory
{

    choices: IRouteChoices = {};

    constructor()
    {
        super();
        this.onResetRouteBaseURLs = this.onResetRouteBaseURLs.bind(this);
        eventBus.on("site.reset-route-base-urls", this.onResetRouteBaseURLs);
    }

    birth(id: string): RouteModel
    {
        return new RouteModel(id);
    }

    birthChoice(choiceID?:string): RouteChoice
    {
        return new RouteChoice(null, choiceID);
    }

    getDefaultModelWithRoute(additionalRouteIDs?: IRouteIDs): RouteModel|null {
        const routeIDs = this.defaultRouteIDs();
        if(additionalRouteIDs){
            cloneObjectTo(additionalRouteIDs, routeIDs);
        }
        return this.getRouteModel(routeIDs);
    }

    getRouteModel(routeIDs: IRouteIDs): RouteModel|null {
        const navigationModel = getManager().navigation.createNavigationModel(routeIDs);
        for(let i = navigationModel.levelList.length - 1; i >= 0; i--) {
            const model = navigationModel.levelList[i].model;
            if(model.factoryID === this.id){
                return model;
            }

        }
        return null;
    }

    getValidParamKeys(routeIDs:IRouteIDs, params:IStringObject): string[]
    {
        return [];
    }

    canUseHash(routeIDs:IRouteIDs):boolean
    {
        return false;
    }

    getAdditionalRouteIDs(routeIDs:IRouteIDs, params: IStringObject, hash: string, suppliedRouteIDs?: IRouteIDs|null): IRouteIDs
    {
        return {};
    }

    defaultRouteIDs(): IRouteIDs
    {
        return {};
    }

    requireModel(populateIDs: IPopulateIDs): RouteModel
    {
        return super.requireModel(populateIDs) as RouteModel;
    }

    onResetRouteBaseURLs()
    {
        for(let modelID in this.conditionModels){
            const model = this.conditionModels[modelID] as RouteModel;
            model.baseURL = "";
            model.clearUiChoiceList();
            for(let choiceID in model.choices){
                const choice = model.choices[choiceID];
                choice.determinedHref = null;
            }
        }
    }
}